import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { useRouter } from 'next/router'
import { cn } from '@/lib/utils'
import { NAV_LINKS } from '@/constants/navigation'

/* A floating pill, fixed to the top centre of every page. It sits OUTSIDE the
 * Loupe section, whose `isolation: isolate` keeps the bead's z-600 from ever
 * painting over it. Top offset plus height stays under the hero's 58px
 * clearance. */
const SiteNav: FC = (): ReactNode => {
    const { pathname } = useRouter()

    return (
        <nav
            aria-label='Main'
            className='fixed left-1/2 top-3 z-50 -translate-x-1/2'
        >
            <ul className='flex items-center gap-0.5 rounded-full border border-foreground/15 bg-background/75 p-1 shadow-[0_8px_24px_-12px_rgba(18,16,22,0.28)] backdrop-blur-md'>
                {NAV_LINKS.map((link) => {
                    const active = pathname === link.href

                    return (
                        <li key={link.href}>
                            <Link
                                href={link.href}
                                aria-current={active ? 'page' : undefined}
                                className={cn(
                                    'inline-flex items-center gap-[7px] rounded-full px-3.5 py-2 text-[11px] font-medium leading-none outline-none transition-colors duration-200 focus-visible:ring-2 focus-visible:ring-foreground/40',
                                    active
                                        ? 'bg-foreground text-background'
                                        : 'text-foreground/60 hover:bg-foreground/[0.06] hover:text-foreground'
                                )}
                            >
                                {active && (
                                    <span
                                        aria-hidden
                                        className='inline-block size-[6px] rotate-45 border border-background'
                                    />
                                )}
                                {link.label}
                            </Link>
                        </li>
                    )
                })}
            </ul>
        </nav>
    )
}

export default SiteNav
